import React from 'react';
import { Paragraph as ParagraphDesign } from '@marty-js/design/src/atoms/paragraph';
import { ParagraphData, PluginComponent } from './types';

export const Paragraph: PluginComponent = ({ children, data }) => {
  const nodeData = data as ParagraphData;

  return <ParagraphDesign className={nodeData?.align}>{children}</ParagraphDesign>;
};
